import React from 'react';
import { Text } from '../../../../UI/Text';
import withCountdown from '../../../../Containers/HOCS/withCountdown';

const Countdown = ({ secondsLeft, onClose }) => {
    if (secondsLeft === -1) onClose();

    return (
        <Text size={'17vw'} weight={'bold'}>
            {secondsLeft !== 0 ? secondsLeft : 'GO!'}
        </Text>
    );
};

// export default Countdown;
export default withCountdown(Countdown, 3);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Repeat/Content/Countdown.js